import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import InsightWrapper from './components/wrapper';
import {  useLocation} from 'react-router-dom';
import InsightItemCard from './components/card';
import { getModuleData,scrollToTop } from './../../common/utils';
import { useAppContext } from '../../common/context';
import AppPagination from './components/pagination';
import "./components/pagination/insightPaginationStyle.scss"

 
function InsightScreen() {
  const {insightTab,  currentPage, getCurrentPage} = useAppContext();
  const { title, category, items, main, base_url } =  getModuleData(insightTab);
  const location = useLocation();
  const {pathname} = location;
 
  const DEFAULT_PAGE = 1;
  const DEFAULT_PAGE_SIZE = 12; 
  const totalCount = items.length || 0;
  const totalPages = Math.ceil(totalCount / DEFAULT_PAGE_SIZE);
  // const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);
  const start = (currentPage - 1) * DEFAULT_PAGE_SIZE;
  const end = DEFAULT_PAGE_SIZE + start
  const isPagination= totalCount > DEFAULT_PAGE_SIZE;

  useEffect(()=>{
    if(pathname !== '/intel-ideas'){
      getCurrentPage(DEFAULT_PAGE);
    }
  }, [pathname, getCurrentPage])
 
  const handlePageChange = (value) => {
    getCurrentPage(value);
    scrollToTop(); 
  };

  return (
    <InsightWrapper
      heroText={title}
      tab="success-story"
      items={main}
      base_url={base_url}
    >
      
      {items && Array.isArray(items) && <InsightItemCard data={items.slice(start, end)} category={category} base_url={base_url} isPagination={isPagination}/>}
 
      <>
        {totalCount > DEFAULT_PAGE_SIZE && (
          <Row className='pagination-container'>
            <Col className=' pagination-element d-flex justify-content-center align-items-center'>
              <AppPagination
                pages={totalPages}
                current={currentPage}
                handlePageChange={handlePageChange}
              />
            </Col>
          </Row>
        )}
      </>
 
    </InsightWrapper>
  )
}
 
export default InsightScreen